import About from '../components/About/Aboutus'
export default function AboutUs() {
    return(
        <main className=" mt-28">
            {/* <p className=" text-center py-20 font-bold text-3xl text-red-500">Page Under Construction</p> */}
            <About />
        </main>
    )
}